$(document).ready(function() {
  if ($('#login-success-on-abo').html() != undefined) {
    if ($('#login-success-on-abo').data('notice') != undefined) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'login',
        site: 'abo'
      });
    }
    setTimeout(function(){
      window.location = 'https://epaper.annabelle.ch';
    }, 1000);
  }
});
